// MealWave Firebase configuration
const mealwaveFirebaseConfig = {
  apiKey: "AIzaSyCVKVIfwEXXQSzjdpLHJ8uSIKG9vI9VHJc",
  authDomain: "mealwave-507ef.firebaseapp.com",
  databaseURL: "https://mealwave-507ef-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mealwave-507ef",
  storageBucket: "mealwave-507ef.firebasestorage.app",
  messagingSenderId: "1041851370572",
  appId: "1:1041851370572:web:a190f6678649ae719af8e9",
  measurementId: "G-KKFW1M63QM"
}

export default mealwaveFirebaseConfig
